<mat-card
  [attr.role]="selectionType"
  [attr.aria-checked]="isSelected"
  tabindex="0"
  matRipple
  [matRippleColor]="rippleColor"
  class="wizard-tile-wrapper"
  [ngClass]="{ 'tileSelected' : isSelected, 'is-full-width-tile': isSingleOption, 'radio-tile': isRadioTile, 'checkbox-tile': isCheckboxTile, 'brand-tile': isBrandsStep }"
  (click)="onTileSelected($event)"
  (keydown.enter)="onTileSelected($event)"
  (keydown.space)="onTileSelected($event)">

  <div class="wizard-tile-contents">
    <div class="wizard-tile-top">
      <div class="column">

        <span class="wizard-tile-icon-wrapper">
          <mat-icon
            class="wizard-tile-icon"
            [ngClass]="{'wizard-tile-icon--svg': wizardOption.iconSvgName}"
            *ngIf="wizardOption.iconFontSet && wizardOption.iconName || wizardOption.iconSvgName"
            [fontSet]="wizardOption.iconFontSet" 
            [fontIcon]="wizardOption.iconName"
            [svgIcon]="wizardOption.iconSvgName"></mat-icon>
        </span>

        <span class="mobile-checkbox-selected-icon-wrapper">
          <mat-icon
            class="unselected-icon"
            fontSet="far"
            fontIcon="fa-square"
            ></mat-icon>

          <mat-icon
            class="selected-icon"
            fontSet="fas"
            fontIcon="fa-check-square"
            ></mat-icon>
        </span>

        <img
          class="wizard-tile-image tile-top-image"
          *ngIf="wizardOption.imgSrc"
          [src]="wizardOption.imgSrc"
          [attr.alt]="wizardOption.title"
          [attr.aria-hidden]="true" />
      </div>
    </div>

    <div
      class="wizard-tile-bottom"
      [ngClass]="{ 'isAlignLeft' : isAlignTextLeft, 'noBottomPadding': removeBottomPadding }">
      <div class="column">
        <mat-card-title class="wizard-tile-title" [ngClass]="{ 'hasTooltip' : tooltipText }">
          <span class="title">{{wizardOption.title}}</span>
          <span class="tooltip-wrapper"
            *ngIf="tooltipText"
            tabindex="0"
            [attr.aria-hidden]="true"
            [attr.aria-label]="tooltipText"
            (focus)="tooltip.show()"
            (blur)="tooltip.hide()"
            >
            <mat-icon
              fontSet="fas"
              fontIcon="fa-info-circle"
              [matTooltip]="tooltipText"
              matTooltipClass="wizard-tooltip"
              #tooltip="matTooltip"
              ></mat-icon>
          </span>
          <span class="mobile-radio-selected-icon-wrapper">
            <mat-icon
              class="selected-icon"
              fontSet="fas"
              fontIcon="fa-check-circle"
              ></mat-icon>
          </span>
        </mat-card-title>
        <mat-card-subtitle class="wizard-tile-subtitle" *ngIf="wizardOption.subtitle">{{wizardOption.subtitle}}</mat-card-subtitle>
        <div class="mobile-brand-image-wrapper">
          <div>
            <img
                class="wizard-tile-image tile-bottom-image"
                *ngIf="wizardOption.imgSrc"
                [src]="wizardOption.imgSrc"
                [attr.alt]="wizardOption.title"
                [attr.aria-hidden]="true" />

            <span *ngIf="!wizardOption.imgSrc">
              <mat-icon
                class="wizard-tile-icon tile-bottom-image"
                *ngIf="wizardOption.iconFontSet && wizardOption.iconName"
                [fontSet]="wizardOption.iconFontSet"
                [fontIcon]="wizardOption.iconName"></mat-icon>
            </span>
          </div>
          <div>
            <mat-card-title class="mobile-brand-title" *ngIf="wizardOption.title">{{wizardOption.title}}</mat-card-title>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-card>

